import { z } from 'zod';

import { SituacaoAlunoEnum } from './enums';
import type { SituacaoAluno } from './enums';

/** Datas como `Date`: `z.coerce.date()` aceita "AAAA-MM-DD" (sempre UTC) e rejeita data inválida sozinho; `c.json()` serializa ISO. */
export type AlunoOutput = {
  id: string;
  nome: string;
  responsavel: string | null;
  telefone: string | null;
  whatsapp: string | null;
  email: string | null;
  dataNascimento: Date | null;
  observacoes: string | null;
  dataMatricula: Date;
  situacao: SituacaoAluno;
  zonaVermelha: boolean;
  connect: boolean;
};

export const AlunoCreateInput = z.object({
  nome: z.string().min(1),
  responsavel: z.string().optional(),
  telefone: z.string().optional(),
  whatsapp: z.string().optional(),
  email: z.email().optional(),
  dataNascimento: z.coerce.date().optional(),
  observacoes: z.string().optional(),
  dataMatricula: z.coerce.date(),
  situacao: SituacaoAlunoEnum.default('ATIVO'),
  zonaVermelha: z.boolean().default(false),
  connect: z.boolean().default(false),
});

export const AlunoUpdateInput = AlunoCreateInput.partial();

export type AlunoOutputType = AlunoOutput;
export type AlunoCreateInputType = z.infer<typeof AlunoCreateInput>;
export type AlunoUpdateInputType = z.infer<typeof AlunoUpdateInput>;
